export const supportEmailUrl = 'mailto:support@rockalingua.com';
